import script from "./consultation-request-success-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./consultation-request-success-modal.vue?vue&type=script&lang=ts&setup=true"

import "./consultation-request-success-modal.vue?vue&type=style&index=0&id=5d5741bc&lang=css"

const __exports__ = script;

export default __exports__